import { render, staticRenderFns } from "./KeyValuesForm.vue?vue&type=template&id=e2b9495e&scoped=true&"
import script from "./KeyValuesForm.vue?vue&type=script&lang=js&"
export * from "./KeyValuesForm.vue?vue&type=script&lang=js&"
import style0 from "./KeyValuesForm.vue?vue&type=style&index=0&id=e2b9495e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b9495e",
  null
  
)

export default component.exports